import script from "./MemberBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberBadge.vue?vue&type=script&setup=true&lang=ts"

import "./MemberBadge.vue?vue&type=style&index=0&id=e20fa618&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e20fa618"]])

export default __exports__